import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MCBPS030CreateRequest } from 'types/MCBPS030/MCBPS030CreateRequest'
import { MCBPS030SelectionFileUploadInitReturnDto } from 'types/MCBPS030/MCBPS030SelectionFileUploadInitReturnDto'
import { MCBPS030UploadResultInfoDto } from 'types/MCBPS030/MCBPS030UploadResultInfoDto'

interface SelectionFileUpdateData {
  initDisplayInfo: MCBPS030SelectionFileUploadInitReturnDto
  confirmAgainFlg: boolean
  uploadResultInfo: MCBPS030UploadResultInfoDto
  historyResult: string
  sackbarOpenFlg: boolean
}

const initialState: SelectionFileUpdateData = {
  initDisplayInfo: {
    selectionFileNameInfoList: [],
    maxSelectionFileUploadCount: '',
  },
  confirmAgainFlg: false,
  uploadResultInfo: {
    jobSeekerByCompanyDisplayInfoList: [],
    updateTargetDataInfoList: [],
    pdfFileNameList: [],
    endMessageId: '',
    messages: [],
  },
  historyResult: '',
  sackbarOpenFlg: false
}

const selectionFileUploadIumpReducer = createSlice({
  name: 'selectionFileUploadIump',
  initialState,
  reducers: {
    iumpInit(state) {
      return state
    },
    setIumpInitResult(state, action: PayloadAction<MCBPS030SelectionFileUploadInitReturnDto>) {
      state.initDisplayInfo = action.payload
    },
    historyConfirm(state) {
      return state
    },
    iumpInsert(state, action: PayloadAction<MCBPS030CreateRequest>) {
      return state
    },
    setConfirmAgainFlg(state, action: PayloadAction<boolean>) {
      state.confirmAgainFlg = action.payload
    },
    setUploadResultInfo(state, action: PayloadAction<MCBPS030UploadResultInfoDto>) {
      state.uploadResultInfo = action.payload
    },
    setsackbarOpenFlg(state, action: PayloadAction<boolean>) {
      state.sackbarOpenFlg = action.payload
    }
  },
})

export const {
  iumpInit,
  setIumpInitResult,
  historyConfirm,
  iumpInsert,
  setConfirmAgainFlg,
  setUploadResultInfo,
  setsackbarOpenFlg
} = selectionFileUploadIumpReducer.actions

export default selectionFileUploadIumpReducer.reducer